






























































































import { Inject } from '@cds/common';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';  
import ModulePermissionPopup from './ModulePermissionPopup.vue';

@Component({
  components: {
    ModulePermissionPopup,
  }
})
export default class ModulePermissionList extends Vue {
  public queryForm: Record<string, any> = {
    pages: 1,
    size: 10,
    current: 1,
    total: 0,
    createTimeRange: [],
    modelCode: '',
    coverName: ''
  }
  public isShowPopup: Boolean = false; // 是否显示权限popup
  public popupId: Number = null;
  public popupKey: number = 0; // 弹窗key，用于强制重新渲染
  public tableData: any[] = [];
  public loading: Boolean = true;

  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  public async created(): Promise<void> {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      createTimeRange: [],
      modelCode: '',
      coverName: ''
    }
    await this.getList();
  }

  //查询接口
  public search() {
    this.queryForm.current = 1;
    this.getList()
  }

  //分页相关
  public handleSizeChange(size: number) {
    this.queryForm.size = size;
    this.getList();
  }

  public handleCurrentChange(current: number) {
    this.queryForm.current = current;
    this.getList();
  }

  //获取数据接口
  public async getList() {
    this.loading = true;
    let params: any = {
      createDateStart: (this.queryForm.createTimeRange || [])[0],
      createDateEnd: (this.queryForm.createTimeRange || [])[1],
      modelCode: this.queryForm.modelCode || '',
      coverName: this.queryForm.coverName || '',
      current: this.queryForm.current,
      size: this.queryForm.size
    };

    try {
      const res = await this.nuoxiaoerService.fetchPermissionList(params);
      this.loading = false;

      const moduleTypeDict = {
        'application': '应用',
        'scenarios': '业务场景',
        'novartis_video': '诺华视界',
      }

      const list = (res.records || []).map(x => {
        return {
          ...x,
          createdTime: x.createdTime ? moment(x.createdTime).format('YYYY-MM-DD HH:mm:ss') : '--',
          modelCodeName: moduleTypeDict[x.modelCode] || x.modelCode,
          // 处理用户范围展示
          openScopeDisplay: (x.openScope || []).join(', '),
          // 处理用户组展示
          userGroupsDisplay: x.userGroups ? x.userGroups.map((g: any) => g.groupName || g.name).join(', ') : '',
          // 处理用户邮箱展示
          emailsDisplay: (x.emails || []).join(', '),
          // 处理封面展示
          appCoversDisplay: (x.appCovers || []).map((c: any) => c.name).join(', ')
        }
      });
      this.tableData = list;

      this.queryForm.total = res.total || 0;
      this.queryForm.pages = res.pages || 0;
      this.queryForm.size = res.size || 10;
      this.queryForm.current = res.current || 1;

    } catch (error) {
      this.loading = false;
      console.error('获取权限列表失败：', error);
      this.$message.error('获取列表数据失败，请稍后重试');
    }
  }

  // 删除
  public async handleDelete(row: any) {
    try {
      // 确认删除
      await this.$confirm('是否删除该信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });

      // 删除数据
      await this.nuoxiaoerService.deletePermission({ id: row.id });

      this.$message({
        message: '删除成功',
        type: 'success'
      });

      // 刷新列表
      this.getList();
    } catch (error) {
      if (error === 'cancel') {
        // 用户取消操作，不做处理
        return;
      }
      console.error('删除失败：', error);
      this.$message.error('删除失败：' + (error.message || '未知错误'));
    }
  }

  // 重置
  public reset() {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      createTimeRange: [],
      modelCode: '',
      coverName: ''
    };
    this.getList()
  }

  /* 打开popup */
  public handleOpenPopup(rowData:any) {
    if (!rowData) {
      console.log('新增');
      this.popupId = null;
      this.popupKey++; // 强制重新渲染组件
      this.isShowPopup = true;
    } else {
      console.log('编辑 rowData:', rowData);
      this.popupId = rowData.id;
      this.popupKey++; // 强制重新渲染组件
      this.isShowPopup = true;
    }
  }

  /* 保存后 */
  public handleAfterSaved() {
    console.log('handleAfterSaved');
    this.getList();
    this.isShowPopup = false;
    this.popupId = null;
    this.popupKey++; // 强制重新渲染组件，清理状态
  }

  /* 取消popup */
  public handleCancelPopup() {
    this.isShowPopup = false;
    this.popupId = null;
    this.popupKey++; // 强制重新渲染组件，清理状态
  }

   /* 关闭popup后 */
  public handleAfterClosePopup() {
    this.popupId = null;
    this.popupKey++; // 强制重新渲染组件，清理状态
  }
}
